import {GetCoinsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {Fade} from '@aboutyou/transitions';
import {
  GenericIconName,
  HEADER_BUTTON_FADE_DURATION,
  HeaderButton,
  Icon,
} from '@aboutyou/ui-components';
import React, {useEffect, useRef} from 'react';
import {useRect} from 'react-viewport-utils';
import {useSuccessMissionState} from '../../../features/Coins/utils/useSuccessMissionState';
import {OffcanvasButton} from '../../Navigation/Components/OffcanvasHeaderComponents';
import {useWalletStateManager} from '../../Wallet/utils/useWalletStateManager';

export const HeaderCoinsWalletButtonView: React.FC<GetCoinsResponse> = ({
  availability,
}) => {
  const {t} = useTranslation();
  const {open} = useWalletStateManager();
  const ariaLabel = t('Open coins wallet');

  const {setOpenerPosition} = useSuccessMissionState();

  const iconRef = useRef<HTMLButtonElement>(null);
  const iconRect = useRect(
    iconRef as React.RefObject<HTMLButtonElement | null>,
    {
      disableScrollUpdates: false,
      priority: 'low',
    },
  );

  useEffect(() => {
    if (iconRect) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setOpenerPosition({
        top: iconRect.top,
      });
    }
  }, [setOpenerPosition, iconRect]);

  const handleOnClick = () => {
    open('coins');
  };

  if (availability?.$case === 'unavailable') {
    return null;
  }

  return (
    <Fade mounted={true} duration={HEADER_BUTTON_FADE_DURATION}>
      {process.env.STACK === 'desktop' ? (
        <HeaderButton
          iconRef={iconRef}
          data-testid="HeaderCoinsWalletButton"
          asset={GenericIconName.Coins}
          iconSize="S"
          onClick={handleOnClick}
          aria-label={ariaLabel}
        />
      ) : (
        <OffcanvasButton
          disableShadow
          onClick={handleOnClick}
          data-testid="HeaderCoinsWalletButton"
          aria-label={ariaLabel}
        >
          <Icon asset={GenericIconName.Coins} size="S" />
        </OffcanvasButton>
      )}
    </Fade>
  );
};
